import rolePerm from '&/store/rolePerm';

const STORE_MODULES = require.context('@/store', false, /\.js$/);
// const COMMON_STORE_MODULES = require.context("&/store", false, /\.js$/);
//eslint-disable-next-line
const store = STORE_MODULES.keys().reduce((store, PATH) => {
    if (PATH === './index.js') return store;
    const KEY = PATH.replace(/^\.\/(.*)\.\w+$/, '$1');
    store[KEY] = STORE_MODULES(PATH).default;
    return store;
}, {});

store.rolePerm = rolePerm;

export default store;
